import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { invitesKey } from "../api/hooks/useInvites";

export function useRevokeInvite(slug: string) {
  const qc = useQueryClient();
  return useMutation<void, ApiError, string>({
    mutationFn: (inviteId: string) =>
      apiFetch<void>(`/api/ws/${slug}/invites/${inviteId}`, { method: "DELETE" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: invitesKey(slug) });
    },
  });
}
